import { memo, useMemo } from "react";
import { Box, Button, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import Tooltip from "../../Tooltip";
import TogglePillGroup, { ToggleOption } from "../../TogglePillGroup";
import OpenWithOutlinedIcon from "@mui/icons-material/OpenWithOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import { useAppSelector } from "../../../store/hooks";
// import { selectIsFreePlan } from "../../../features/pricingPlans/pricingPlans.selector";

export type ChartMode = "panning" | "zooming";

export type ChartsToolbarProps = {
  filters: ToggleOption<number>[];
  selectedFilter: number;
  onFilterChange: (filter: ToggleOption<number>, index: number) => void;
  mode: ChartMode;
  onModeChange: (mode: ChartMode) => void;
  asin: string;
  hideOpenNew?: boolean;
  onOpenExternal?: () => void;
};

function ChartsToolbarBase({
  filters,
  selectedFilter,
  onFilterChange,
  mode,
  onModeChange,
  asin,
  hideOpenNew,
  onOpenExternal,
}: ChartsToolbarProps) {
  // const isFreePlan = useAppSelector(selectIsFreePlan);

  // const updatedFilters = useMemo(() => {
  //   return filters.map((filter) => ({
  //     ...filter,
  //     disabled: isFreePlan && (filter.value === 0 || filter.value >= 90),
  //   }));
  // }, [filters, isFreePlan]);

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      flexWrap={"wrap"}
      px={"4px"}
      py={"4px"}
      gap="4px"
    >
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gap="4px"
        marginRight="8px"
      >
        <TogglePillGroup
          options={filters}
          selectedValue={selectedFilter}
          onChange={onFilterChange}
          size="small"
        />
      </Box>
      <Tooltip title={"Drag the chart along with the data line"}>
        <Button
          size="small"
          variant={mode === "panning" ? "contained" : "outlined"}
          onClick={() => onModeChange("panning")}
        >
          <SvgIcon component={OpenWithOutlinedIcon} sx={{ fontSize: "14px" }} />
        </Button>
      </Tooltip>
      <Tooltip title={"Select an area on the chart to zoom in"}>
        <Button
          size="small"
          variant={mode === "zooming" ? "contained" : "outlined"}
          onClick={() => onModeChange("zooming")}
          sx={{ marginRight: "8px" }}
        >
          <SvgIcon component={ZoomInOutlinedIcon} sx={{ fontSize: "18px" }} />
        </Button>
      </Tooltip>
      {!hideOpenNew && (
        <Tooltip title={"Open this chart in a new window"}>
          <Button size="small" variant="contained" onClick={onOpenExternal}>
            <SvgIcon
              component={OpenInNewOutlinedIcon}
              sx={{ fontSize: "16px" }}
            />
          </Button>
        </Tooltip>
      )}
      <Tooltip title={"View chart on keepa"}>
        <Button
          size="small"
          variant="contained"
          component={Link}
          to={`https://keepa.com/#!product/1-${asin}`}
          target="_blank"
        >
          <SvgIcon
            component={InsertChartOutlinedIcon}
            sx={{ fontSize: "16px" }}
          />
        </Button>
      </Tooltip>
    </Box>
  );
}

export default memo(ChartsToolbarBase);
